import React, { useState } from "react";
import Logo from "../assets/images/logo.png";
function Sidebar() {
  const [show, setShow] = useState(false);

  const openMenu = (e) => {
    e.preventDefault();
    setShow(!show);
    document.body.classList.toggle("slide");
  };

  return (
    <>
      <a
        href="/"
        onClick={openMenu}
        className={`js-oliven-nav-toggle oliven-nav-toggle${
          show ? " active" : ""
        }`}
      >
        <i></i>
      </a>
      <aside id="oliven-aside">
        <div className="oliven-logo">
          <a href="/">
            <img src={Logo} alt="" />
            <span>
              Thẩm Mỹ <small>&</small> Nhật Vương
            </span>
            <h6>05.04.2025</h6>
          </a>
        </div>
        <nav className="oliven-main-menu">
          <ul>
            <li>
              <a href="#home">Home</a>
            </li>
            <li>
              <a href="#couple">Giới thiệu</a>
            </li>
            <li>
              <a href="#wedding-story">Câu chuyện</a>
            </li>
            <li>
              <a href="#wedding-seeyou">Ngày tổ chức</a>
            </li>
            <li>
              <a href="#invitation-frame">Thiệp mời</a>
            </li>
            <li>
              <a href="#wedding-row">Bộ sưu tập</a>
            </li>
            <li>
              <a href="#map-header">Vị trí tổ chức</a>
            </li>
            <li>
              <a href="#wedding-wishes">Lời chúc</a>
            </li>
          </ul>
        </nav>
        <div className="footer1">
          {" "}
          <span className="separator"></span>
          <p>Copyright belongs to Phat Tai</p>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
